import { Component, getAssetPath, h, Host, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import { Store } from '../../../utils/Stores/store';

@Component({
  tag: 'technical-emergency',
  styleUrl: 'technical-emergency.scss',
  shadow: true,
})
export class TechnicalEmergency {
  @State() hasAcceptedEmergency = false;

  private acceptanceChange(event) {
    this.hasAcceptedEmergency = event.target.checked;
  }

  private goToEmergencyPage() {
    const emergencyUrl =
      wcShared?.store?.productsRouting?.welcome +
      '/support/' +
      Store?.get('supportPremium').vipCode;
    window.open(emergencyUrl, '_blank', 'noopener,noreferrer');
  }

  render() {
    return (
      <Host>
        <div class={{ 'tech-emergency': true, 'tech-emergency--full': Store?.get('is_full') }}>
          <div class="tech-emergency__container">
            <div class="support-ik">
              <img
                src={getAssetPath('./../assets/rounded-icons/icon-headset-white-bg.svg')}
                alt="Support Infomaniak"
              />
              <span>{wcShared?.translate('Support infomaniak')}</span>
            </div>

            <div class="emergency-block">
              <div class="emergency-block__title">{wcShared?.translate('Urgence critique')}</div>

              <div class="emergency-block__opening-time">
                <div>
                  <img
                    src={getAssetPath('./../assets/icons/calendar.svg')}
                    alt="Calendar"
                  />
                  {wcShared?.translate('7 jours /7')}
                </div>
                <div>
                  <img
                    src={getAssetPath('./../assets/icons/time-clock-circle.svg')}
                    alt="Time clock"
                  />
                  {wcShared?.translate('24h a 24h')}
                </div>
              </div>

              <div class="emergency-block__info-box">
                <img
                  src={getAssetPath('./../assets/icons/information.svg')}
                  alt={wcShared.translate('Icon information')}
                />
                <p>
                  {wcShared?.translate(
                    "L'urgence critique est strictement reservee en cas de problemes lies a l'infrastructure et necessitant une intervention d'infomaniak.",
                  )}
                </p>
              </div>

              <div class="emergency-block__valid-reasons">
                <div
                  class="reasons-list"
                  innerHTML={wcShared?.translate(
                    "Vous pouvez demander a etre rappele <strong>d'ici 15 minutes</strong> par un responsable technique <strong>dans les cas suivants</strong> :",
                  )}
                ></div>
                <div class="reasons-list__line">
                  <img
                    src={getAssetPath('./../assets/icons/alert.svg')}
                    alt={wcShared?.translate('Attention')}
                  />
                  <span>{wcShared?.translate('Coupure de reseau')}</span>
                </div>
                <div class="reasons-list__line">
                  <img
                    src={getAssetPath('./../assets/icons/alert.svg')}
                    alt={wcShared?.translate('Attention')}
                  />
                  <span>
                    {wcShared?.translate(
                      "Interruption de service necessitant une intervention d'Infomaniak",
                    )}
                  </span>
                </div>
                <div class="reasons-list__line">
                  <img
                    src={getAssetPath('./../assets/icons/alert.svg')}
                    alt={wcShared?.translate('Attention')}
                  />
                  <span>{wcShared?.translate('Serveur innacessible')}</span>
                </div>
              </div>

              <div
                class="emergency-block__callback-time"
                innerHTML={wcShared?.translate('Rappel garantit : <strong>15 min</strong>')}
              ></div>

              <div class="emergency-block__confirmation-checkbox">
                <label>
                  <input
                    onChange={(e) => this.acceptanceChange(e)}
                    type="checkbox"
                    name="emergency-validation"
                  />
                  {wcShared?.translate("Je confirme qu'il s'agit d'une urgence technique critique")}
                </label>
              </div>

              <div class="emergency-block__submit">
                <button
                  disabled={!this.hasAcceptedEmergency}
                  onClick={() => this.goToEmergencyPage()}
                >
                  {wcShared?.translate("Continuer vers la demande de rappel d'urgence")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
